import Vue from 'vue';
import ApiClient from '@/libs/api_client';

const DESTINATION_TYPE = {
  restroom: 'restroom',
  spot: 'spot',
  person: 'pseron',
  item: 'item',
};

export default {
  strict: true,
  namespaced: true,
  state: {
    editingDestinations: [],
    destinations: [],
    destination: {},
  },
  getters: {
    all: (state) => state.destinations,
    spotAll: (state) => state.destinations.filter((destination) => destination.destinationType === DESTINATION_TYPE.spot),
    spotFind: (state, getters) => (spotId) => getters.spotAll.find((spot) => spot.id === spotId),
    restroomAll: (state) => state.destinations.filter((destination) => destination.destinationType === DESTINATION_TYPE.restroom),
    restroomFind: (state, getters) => (restroomId) => getters.restroomAll.find((spot) => spot.id === restroomId),
    personAll: (state) => state.destinations.filter((destination) => destination.type === DESTINATION_TYPE.user),
    personFind: (state, getters) => (userId) => getters.personAll.find((user) => user.id === userId),
    itemAll: (state) => state.destinations.filter((destination) => destination.type === DESTINATION_TYPE.item),
    itemFind: (state, getters) => (itemId) => getters.itemAll.find((item) => item.id === itemId),
  },
  mutations: {
    setDestinations(state, destinations) {
      Vue.set(state, 'destinations', destinations);
    },
    setEditingDestinations(state, destinations) {
      Vue.set(state, 'editingDestinations', destinations);
    },
    setDestination(state, destination) {
      Vue.set(state, 'destination', destination);
    },
    clearDestinations(state) {
      state.destinations = [];
    },
    clearDestination(state) {
      state.destination = {};
    },
  },
  actions: {
    async searchDestinations(context, payload) {
      context.commit('dialog/startLoad', null, { root: true });
      try {
        const params = {
          keyword: payload.keyword,
          options: payload.options,
          exclusionTypes: payload.exclusionTypes,
        };
        const destinations = await ApiClient.getPlaceDestinations(payload.placeId, params);
        context.commit('setDestinations', destinations);
      } finally {
        context.commit('dialog/finishLoad', null, { root: true });
      }
    },
    async searchEditingDestinations(context, payload) {
      try {
        const params = {
          keyword: payload.keyword,
          options: payload.options,
          exclusionTypes: payload.exclusionTypes,
        };
        const destinations = await ApiClient.getPlaceDestinations(payload.placeId, params);
        context.commit('setEditingDestinations', destinations);
      } finally {}
    },
    async getSpot(context, spotId) {
      context.commit('dialog/startLoad', null, { root: true });

      try {
        const spot = await ApiClient.getSpot(spotId);
        context.commit('setDestination', spot);
      } finally {
        context.commit('dialog/finishLoad', null, { root: true });
      }
    },
    async getThing(context, thingId) {
      context.commit('dialog/startLoad', null, { root: true });

      try {
        const thing = await ApiClient.getThing(thingId);
        context.commit('setDestination', thing);
      } finally {
        context.commit('dialog/finishLoad', null, { root: true });
      }
    },
    clearDestinations({ state, commit }) {
      state.destinations = [];
      commit('destinationList/hide', null, { root: true });
    },
    clearDestination({ state, dispatch }) {
      state.destination = {};
      dispatch('destinationDetail/hide', null, { root: true });
    },
    allClearDestinations({ state, dispatch, commit }) {
      dispatch('clearDestinations');
      dispatch('clearDestination');
    },
  },
};



// WEBPACK FOOTER //
// ./src/stores/map/models/search_result.js